import Util from "./Util.js";
//
import { gsap } from "./Util.js";
import { CustomEase } from "./Util.js";

class Toggle extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    if (document.querySelectorAll(".toggle-trigger").length > 0) {
      this.setVars();
      this.events();
    }
  }

  setVars() {
    this.triggers = document.querySelectorAll(".toggle-trigger");
  }

  events() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const target = trigger.nextElementSibling;
        const marginTop = parseFloat(window.getComputedStyle(target.children[0]).marginTop);
        if (!trigger.classList.contains("active")) {
          trigger.classList.add("active");
          gsap.to(target, 0.3, {
            height: target.children[0].getBoundingClientRect().height + marginTop,
            onComplete: () => {
              trigger.classList.add("active");
            },
          });
        } else {
          trigger.classList.remove("active");
          gsap.to(target, 0.3, {
            height: 0,
            onComplete: () => {
              trigger.classList.remove("active");
            },
          });
        }
      });
    });
  }
}

export default Toggle;
